import script from "./InfoInfraComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoInfraComponent.vue?vue&type=script&setup=true&lang=js"

import "./InfoInfraComponent.vue?vue&type=style&index=0&id=72a198fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a198fa"]])

export default __exports__